import { useEffect } from 'react';

import { faClock, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const cap = s => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '');

export default function EventModal({ event, onClose, isClosing }) {
    useEffect(() => {
        const handleEsc = e => {
            if (e.key === 'Escape') onClose();
        };

        document.addEventListener('keydown', handleEsc);
        document.body.classList.add('no-scroll');

        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.classList.remove('no-scroll');
        };
    }, [onClose]);

    const categoryLabel = event.categoryKey === 'fellesprogram' ? 'Felles' : cap(event.categoryKey);

    return (
        <div className={`program-modal ${isClosing ? 'is-closing' : ''}`} onClick={onClose}>
            <div
                className={`program-modal__content program-modal__${event.categoryKey}`}
                onClick={e => e.stopPropagation()}
            >
                <button className="program-modal__close" onClick={onClose} aria-label="Lukk">
                    ×
                </button>

                <div className="program-modal__header">
                    <h2 className="program-modal__title">{event.title}</h2>
                    <div className="program-modal__tag">{categoryLabel}</div>
                </div>

                <div className="program-modal__meta">
                    <div className="program-modal__meta-item">
                        <FontAwesomeIcon icon={faClock} size="sm" />
                        {event.startTime}–{event.endTime}
                    </div>
                    {event.location && (
                        <div className="program-modal__meta-item">
                            <FontAwesomeIcon icon={faMapMarkerAlt} size="sm" />
                            {event.location}
                        </div>
                    )}
                </div>

                {event.description && (
                    <div
                        className="program-modal__body"
                        dangerouslySetInnerHTML={{ __html: event.description }}
                    />
                )}
            </div>
        </div>
    );
}
